import useAxios from "axios-hooks";
import React, { useRef, useState } from "react";
import { YMaps, Map, Placemark } from "react-yandex-maps";
import classNames from "classnames";

import Api from "../../api";
import SeoBlock from "../../components/seo_block/SeoBlock";
import { Button } from "../../components";
import TelegramIcon from "../../assets/svg/telegram.svg";
import CompanyPlacemarkSrc from "../../assets/images/map_placemark.svg";
import { request } from "../../api";

import styles from "./map.module.scss";

const MapPage = ({ contact }) => {
  const mapItem = useRef();

  const [{ data }] = useAxios({ url: Api.conatcts_for_map });

  const seo = data ? data.seo : {};

  const [mapData, setMapData] = useState({
    center: [56.009492, 92.81438],
    zoom: 4,
    // behaviors: ["disable('scrollZoom')"]
  });

  const zoomToPoint = (coords) => {
    setMapData((mapData) => {
      return {
        ...mapData,
        center: coords.split(",").map((i) => {
          return parseFloat(i);
        }),
        zoom: 16,
      };
    });
  };

  const pins = data?.contacts?.map((item, index) => {
      if (!item.show_on_map) return;

      const imgPath =  item.logo?.url ? `${request}${item.logo.url}` : CompanyPlacemarkSrc;
  
      return (
        <Placemark
          key={index}
          geometry={item.coords.split(",")}
          options={{
            iconLayout: "default#image",
            iconImageHref: imgPath,
            iconImageSize: [35, 50],
            iconImageOffset: [-17, -65],
          }}
          onClick={(e) => {
            zoomToPoint(item.coords);
          }}
        />
      );
    });

  const socialLinks =
    data?.social_list?.map((socialLink) => {
      const { hostname } = new URL(socialLink);

      let domain = hostname.substring(0, hostname.indexOf("."));

      if (domain === "t") {
        domain = "telegram";
      }

      return (
        <li key={socialLink}>
          <a
            href={socialLink}
            className={styles.SocialLink}
            target="_blank"
            rel="noreferrer"
          >
            {domain}
          </a>
        </li>
      );
    });

  return (
    <div className="main-container main-container_large-top-indent">
      <SeoBlock data={seo} contact={contact} />

      <div className="holder wrap no-pdn-top">
        <div className={styles.Contacts}>
          <div>
            <p className={styles.StartProject}>Начать проект</p>

            <Button
              href="https://t.me/proektmarketing_chat"
              target="_blank"
              className={styles.Button}
              isBlack
              withoutHover
            >
              <img
                src={TelegramIcon}
                alt="Иконка телеграм"
                className={styles.TelegramIcon}
              />

              <span className={styles.ButtonText}>Telegram</span>
            </Button>
          </div>

          {data && data.contacts.map((item, index) => {
            if (item.hided) return;

            return (
              <div
                key={index}
                itemProp="address"
                itemScope=""
                itemType="http://schema.org/PostalAddress"
                onClick={(e) => {
                  zoomToPoint(item.coords);
                }}
                className={styles.Contact}
              >
                <div className={styles.mapContactTitle}>{item.city}</div>
                <div className={styles.mapContactText}>
                  <p>
                    {`${item.street_address} ${item.local_address}`}
                    <br />
                    {item.open_time}
                  </p>
                  <p>
                    <a
                      className={styles.ContactLink}
                      itemProp="email"
                      href={`mailto:${item.email}`}
                      target="_self"
                    >
                      {item.email}
                    </a>
                  </p>
                  <p>
                    <a
                      className={styles.ContactLink}
                      href={`tel:${item.phone}`}
                      itemProp="telephone"
                      target="_self"
                    >
                      {item.phone}
                    </a>
                  </p>
                </div>
              </div>
            );
          })}

          <ul className={styles.SocialList}>{socialLinks}</ul>
        </div>

        <div className={styles.mapMain} id="map">
          <YMaps>
            <div className={styles.MapWrapper}>
              <Map
                defaultState={mapData}
                state={mapData}
                ref={mapItem}
                width="100%"
                height="100%"
              >
                {pins}
              </Map>
            </div>
          </YMaps>
        </div>

        <ul className={classNames(styles.SocialList, styles.MobileOnly)}>
          {socialLinks}
        </ul>
      </div>
    </div>
  );
};

export default MapPage;
